import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrFrameTextFont } from "../../../../../redux/slices/qrFrames";
import { FONTS } from "../../../../../constants/inputValues";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

function FrameTextFont() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.frame
  );
  const frameTextFont = useSelector((state) => state.qrFrames.frameTextFont);

  const [textFrameFont, setTextFrameFont] = useState(frameTextFont);
  const dispatch = useDispatch();

  useEffect(() => {
    setTextFrameFont(frameTextFont);
  }, [frameTextFont]);

  useEffect(() => {
    dispatch(qrFrameTextFont(textFrameFont));
  }, [textFrameFont]);

  return (
    <>
      <FloatingLabel label={lang[4]}>
        <Form.Select
          name="font"
          value={textFrameFont}
          onChange={(e) => setTextFrameFont(e.target.value)}
        >
          {FONTS.map((font) => (
            <option key={font} value={font}>
              {font}
            </option>
          ))}
        </Form.Select>
      </FloatingLabel>
    </>
  );
}

export default memo(FrameTextFont);
